import { connect } from 'react-redux';
import { NewExistingRadio } from '@zocdoc/components/src/newexistingradio';
import { selectPatientStatus } from '@zocdoc/components/src/newexistingradio/NewExistingRadioActions';
import { mapStateToProps } from './mapStateToProps';

const mapDispatchToProps = { selectPatientStatus };

export default connect(mapStateToProps, mapDispatchToProps)(NewExistingRadio);
